import { render, staticRenderFns } from "./companionsMobile.vue?vue&type=template&id=5b13ce71&scoped=true"
import script from "./companionsMobile.vue?vue&type=script&lang=js"
export * from "./companionsMobile.vue?vue&type=script&lang=js"
import style0 from "./companionsMobile.vue?vue&type=style&index=0&id=5b13ce71&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13ce71",
  null
  
)

export default component.exports